import { liveSessionManager } from '@saucelabs/sl-util-axios';

const createSession = (capabilities) => (
  liveSessionManager.post('/v1/lsm/session', { capabilities })
);

const getChannelStatus = (sessionId) => (
  liveSessionManager.head(`/v1/lsm/session/${sessionId}/channel`)
);

const getSessionInfo = (sessionId) => (
  liveSessionManager.get(`/v1/lsm/session/${sessionId}/info`)
);

const getWebRtcInfos = (sessionId) => (
  liveSessionManager.post(`/v1/lsm/session/${sessionId}/webrtc`)
);

export default {
  createSession,
  getChannelStatus,
  getSessionInfo,
  getWebRtcInfos,
};
